import { takeEvery } from 'redux-saga'
import { call, put, select, spawn, all} from 'redux-saga/effects'
import actionTypes from 'redux/actions/actionTypes'
import { lessonSync, interactiveVideoSync } from 'sync'
import assetSync from 'sync/asset_sync'
import myLibraryLessonsWithoutData from 'redux/selectors/media_slides/my_library_lessons_id_without_data'
import storeLessonsWithoutData from 'redux/selectors/media_slides/store_lessons_id_without_data'
import privateLibraryLessonsWithoutData from 'redux/selectors/media_slides/private_library_lessons_id_without_data'
import callAny from './helpers/call_any'
import mediaSlidesActions from 'redux/actions/mediaSlidesActions'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import formatError from './helpers/error_formatter'

function *getMediaSlide(lessonUid) {
	try {
		const customSlidesResponse = yield callAny(lessonSync.getCustomSlides, lessonUid)
		const externalLessonUid = customSlidesResponse.payload.custom_slides[0].uid
		const jwt = customSlidesResponse.payload.custom_slides[0].jwt
		const slideResponse = yield callAny(interactiveVideoSync.getSlideData, jwt, externalLessonUid)
		const mediaResponse = yield callAny(
			interactiveVideoSync.getInteractiveVideoData,
			jwt,
			slideResponse.payload.entityUid,
			'published'
		)
		const video = yield callAny(interactiveVideoSync.getAssetVideo, mediaResponse.asset.uid, jwt)
		yield put(mediaSlidesActions.mediaSlideFetched(mediaResponse, lessonUid, externalLessonUid, video))
		return {
			mediaResponse,
			lessonUid,
			externalLessonUid,
			jwt,
		}
	} catch (error) {
		const formattedError = formatError(error)
		yield put(mediaSlidesActions.mediaSlideFetchedFailed(formattedError, lessonUid))
	}
}

function *getMyLibraryMediaSlides() {
	try {
		const lessonsWithoutDataSelector = yield select(myLibraryLessonsWithoutData)
		yield lessonsWithoutDataSelector.lessonsIdWithoutData.map(
			lessonUid => spawn(getMediaSlide, lessonUid)
		)
	} catch (error) {
		const formattedError = formatError(error)
		yield put(mediaSlidesActions.myLibraryMediaSlideFetchFailed(formattedError))
	}
}

function *getStoreMediaSlides() {
	try {
		const lessonsWithoutDataSelector = yield select(storeLessonsWithoutData)
		yield lessonsWithoutDataSelector.lessonsIdWithoutData.map(
			lessonUid => spawn(getMediaSlide, lessonUid)
		)
	} catch (error) {
		const formattedError = formatError(error)
		yield put(mediaSlidesActions.storeMediaSlideFetchFailed(formattedError))
	}
}

function *getPrivateLibraryMediaSlides() {
	try {
		const lessonsWithoutDataSelector = yield select(privateLibraryLessonsWithoutData)
		yield lessonsWithoutDataSelector.lessonsIdWithoutData.map(
			lessonUid => spawn(getMediaSlide, lessonUid)
		)
	} catch (error) {
		const formattedError = formatError(error)
		yield put(mediaSlidesActions.privateLibraryMediaSlideFetchFailed(formattedError))
	}
}

function *getHandoutBinary(jwt, assetUid) {
	try {
		const handoutAsset = yield callAny(
			assetSync.getBinary,
			assetUid,
			jwt,
		)
		return handoutAsset
	} catch (error) {
		return null
	}
}

function *getMediaHandouts(jwt, mediaUid) {
	try {
		const handoutsResponse = yield callAny(
			interactiveVideoSync.getHandouts,
			mediaUid,
			jwt,
		)
		const assets = yield all(handoutsResponse.mediaHandouts.map(
			handout => getHandoutBinary(jwt, handout.assetUid)
		))
		const mediaHandouts = handoutsResponse.mediaHandouts
		yield put(interactiveVideoActions.handoutsFetched(mediaUid, mediaHandouts, assets))

	} catch (error) {
		//
	}
}

function *getPreviewMediaSlide(data) {
	try {
		const response = yield call(getMediaSlide, data.presentation_uid)
		yield put(mediaSlidesActions.getPreviewMediaSlideFetched(response))
		yield spawn(getMediaHandouts, response.jwt, response.mediaResponse.uid)
	} catch (error) {
		const formattedError = formatError(error)
		yield put(mediaSlidesActions.getPreviewMediaSlideFailed(formattedError))
	}
}

export default [
	takeEvery(actionTypes.MY_LIBRARY_LESSONS_FETCHED, getMyLibraryMediaSlides),
	takeEvery([
		actionTypes.MY_LIBRARY_INITIALIZE_VIDEO_PREVIEW,
		actionTypes.PRIVATE_LIBRARY_INITIALIZE_VIDEO_PREVIEW,
		actionTypes.STORE_INITIALIZE_VIDEO_PREVIEW,
	],
	getPreviewMediaSlide),
	takeEvery([
		actionTypes.STORE_SEARCH_GET_RESULTS_SUCCESS,
		actionTypes.STORE_FOLDER_GET_RESULTS_SUCCESS,
	],
	getStoreMediaSlides),
	takeEvery(actionTypes.PRIVATE_LIBRARY_LESSONS_FETCHED, getPrivateLibraryMediaSlides),
]

export {
	getMediaSlide,
	getMyLibraryMediaSlides,
}
